import React, { useEffect, useState } from 'react';

import FullScreenSpinner from '@/components/common/FullScreenSpinner/FullScreenSpinner';
import useDisableBodyScroll from '@/hooks/useToggleBodyScroll.hook';

import { LoadingAnimationContext } from './LoadingAnimationContext';
import { loadingAnimationManager } from '@/apollo/links/loadingAnimationLink';


interface ILoadingAnimationProviderProps {
  children: any;
  spinner?: JSX.Element;
}

export function LoadingAnimationProvider({ children, spinner }: ILoadingAnimationProviderProps) {
  const [activeInstanceIds, setActiveInstanceIds] = useState<UUID[]>([]);
  const { toggleBodyScroll } = useDisableBodyScroll();

  const spinnerComponent = spinner || <FullScreenSpinner />;
  const isVisibleSpinner = activeInstanceIds.length > 0;
  const isEnabledPageScroll = !isVisibleSpinner;

  const toggleLoadingAnimation = (isVisble: boolean, id: UUID) => {
    if (isVisble && !activeInstanceIds.includes(id)) {
      setActiveInstanceIds((prevState) => [
        ...prevState,
        id
      ]);
    }
    else {
      setActiveInstanceIds(
        activeInstanceIds.filter((activeId) => activeId !== id)
      );
    }
  };

  useEffect(() => {
    toggleBodyScroll(isEnabledPageScroll);

    return () => toggleBodyScroll(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeInstanceIds]);

  useEffect(() => {
    loadingAnimationManager.setToggleFunction(toggleLoadingAnimation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LoadingAnimationContext.Provider
      value={{
        toggleLoadingAnimation,
        isVisibleLoadingAnimation: isVisibleSpinner
      }}
    >
      {children}

      {isVisibleSpinner && spinnerComponent}
    </LoadingAnimationContext.Provider>
  );
}